import React from 'react';
import type { AchievableResult } from '@/types/diary';

interface Props {
  results: AchievableResult[];
}

export const PlanTransversalSkillsCard: React.FC<Props> = ({ results }) => (
  <div className="flex flex-col gap-4 rounded-xl bg-info-surface p-4">
    {results.map((result) => (
      <div key={result.name ?? result.skills.join()}>
        {!!result.name && (
          <p className="text-subhead-14 mb-2 text-foreground">{result.name}</p>
        )}
        <ul className="flex flex-col gap-2">
          {result.skills.map((skill) => (
            <li key={skill} className="flex gap-2">
              <span className="mt-[7px] size-1.5 shrink-0 rounded-full bg-primary" />
              <span className="text-body-14 text-muted-foreground">
                {skill}
              </span>
            </li>
          ))}
        </ul>
      </div>
    ))}
  </div>
);
